import { render, staticRenderFns } from "./channel_authorization.vue?vue&type=template&id=08a76e70&scoped=true"
import script from "./channel_authorization.vue?vue&type=script&lang=js"
export * from "./channel_authorization.vue?vue&type=script&lang=js"
import style0 from "./channel_authorization.vue?vue&type=style&index=0&id=08a76e70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a76e70",
  null
  
)

export default component.exports